export default __webpack_public_path__ + "static/media/ic_todos_active.9b717cff.svg";